import { defaultRegistry } from './registry';
export async function uninstallApp(options) {
  const {
    appId,
    providerKey,
    registry = defaultRegistry
  } = options;
  const components = await registry.resolveComponents(appId, providerKey);
  if (!components) {
    throw new Error(`[unified-auth] No auth provider found for appId: ${appId}`);
  }
  return components.uninstallApp(appId);
}